<template>
	<div class="home">
		<tabbar></tabbar>
    <activitylist></activitylist>
<!--    <router-view></router-view>-->
<!--		<div class="home-content">-->
<!--			<keep-alive>-->
<!--				<router-view></router-view>-->
<!--			</keep-alive>-->
<!--		</div>-->
	</div>
</template>
<script>
  export default{
    name:'home',
  };
</script>



// WEBPACK FOOTER //
// src/pages/home.vue